import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Minesweeper from './modules/index';

ReactDOM.render(
  <React.StrictMode>
    <Minesweeper />
  </React.StrictMode>,
  document.getElementById('root')
);

